import React, { FunctionComponent, memo } from "react";
import classNames from "classnames";

import { IProps } from "./slider-rail.types";
import "./slider-rail.scss";

/**
 * Slider rail
 * @param props.getRailProps
 * @param props.railInnerClassName
 * @param props.railOuterClassName
 */
const SliderRail: FunctionComponent<IProps> = ({ getRailProps, railInnerClassName, railOuterClassName }) => {
    const railInnerClassnames = classNames("metric-slider__rail__inner", railInnerClassName);
    const railOuterClassnames = classNames("metric-slider__rail__outer", railOuterClassName);

    return (
        <>
            <div className={railOuterClassnames} {...getRailProps()} />
            <div className={railInnerClassnames} />
        </>
    );
};

export default memo(SliderRail);
